<div class="wx taf">
  <div *ngIf="translated; else raw" class="wx__translated">
    <div class="wx__header">
      <div class="wx__header-field">
        <div class="wx__station">
          <div class="wx__station-text">{{ taf.stationId }} TAF</div>
          <div *ngIf="distance !== null && direction" class="wx__distance">
            {{ distance | number: '1.0-0' }} nm {{ direction }}
          </div>
        </div>
      </div>
      <div class="wx__header-field">
        <div class="wx__header-field wx__field wx__issue-time-field">
          <div class="wx__field-label">Issued:</div>
          <div class="wx__field-value">
            <div class="wx__issue-time">{{ issueTimeLocal }}</div>
            <div class="wx__issue-time-ago">({{ taf.issueTime| amTimeAgo }})</div>
          </div>
        </div>
      </div>
    </div>
    <div class="wx__body">
      <div *ngFor="let forecast of taf.forecasts" class="wx__section taf__forecast"
           [class.taf__forecast--vfr]="forecast.flightCategory === 'VFR'"
           [class.taf__forecast--mvfr]="forecast.flightCategory === 'MVFR'"
           [class.taf__forecast--ifr]="forecast.flightCategory === 'IFR'"
           [class.taf__forecast--lifr]="forecast.flightCategory === 'LIFR'">
        <div class="wx__section-header taf__forecast-header">
          <app-wx-icon [flightCategory]="forecast.flightCategory" class="taf__forecast-category"></app-wx-icon>
          <div class="taf__forecast-range">{{ formatForecastRange(forecast) }}</div>
          <div class="taf__forecast-badge" *ngIf="forecast.changeIndicator && forecast.changeIndicator !== 'FM'">
            {{ formatChangeIndicator(forecast) }}
          </div>
        </div>
        <div class="wx__section-body taf__forecast-body">
          <div class="wx__field">
            <div class="wx__field-label">Vis:</div>
            <div class="wx__field-value">
              <ng-container *ngIf="forecast.visibility; else na">
                <span class="wx__value" [innerHTML]="forecast.visibility"></span>
                <span class="wx__unit">SM</span>
              </ng-container>
            </div>
          </div>
          <div class="wx__field">
            <div class="wx__field-label">Wind:</div>
            <div class="wx__field-value">
              <app-wind *ngIf="forecast.wind; else na" [wind]="forecast.wind"></app-wind>
            </div>
          </div>
          <div *ngIf="forecast.windShearHgtFtAgl && forecast.windShearSpeedKt && forecast.windShearDirDegrees" class="wx__field">
            <div class="wx__field-label">Wind Shear:</div>
            <div class="wx__field-value">
              <span class="wx__value" [innerHTML]="forecast.windShearHgtFtAgl"></span>
              <span class="wx__unit">FT AGL</span><br />
              <span class="wx__value" [innerHTML]="forecast.windShearDirDegrees + '&deg;' + '@' + forecast.windShearSpeedKt"></span>
              <span class="wx__unit">KT</span>
            </div>
          </div>
          <div *ngIf="forecast.turbulence && forecast.turbulence.length > 0" class="wx__field">
            <div class="wx__field-label">Turb:</div>
            <ul class="wx__field-value">
              <li *ngFor="let layer of forecast.turbulence">
                <span class="wx__value" *ngIf="layer.minAlt && layer.maxAlt" [innerHTML]="layer.minAlt + ' - ' + layer.maxAlt"></span><br />
                <span class="wx__value" [innerHTML]="layer.intensity"></span>
              </li>
            </ul>
          </div>
          <div class="wx__field wx__field--full-width">
            <div class="wx__field-label">Cld:</div>
            <div class="wx__field-value">
              <app-sky-conditions *ngIf="forecast.skyConditions && forecast.skyConditions.length > 0; else na"
                                  [skyConditions]="forecast.skyConditions"></app-sky-conditions>
            </div>
          </div>
          <div *ngIf="forecast.icing && forecast.icing.length > 0" class="wx__field">
            <div class="wx__field-label">Icing:</div>
            <ul class="wx__field-value">
              <li *ngFor="let layer of forecast.icing">
                <span class="wx__value" *ngIf="layer.minAlt && layer.maxAlt" [innerHTML]="layer.minAlt + ' - ' + layer.maxAlt"></span><br />
                <span class="wx__value" [innerHTML]="layer.intensity"></span>
              </li>
            </ul>
          </div>
          <div class="wx__field">
            <div class="wx__field-label">Wx:</div>
            <div class="wx__field-value">
              <span *ngIf="forecast.wxStringTrans; else na" [innerHTML]="forecast.wxStringTrans" class="wx__wx"></span>
            </div>
          </div>
          <a href="https://www.aopa.org/weather/?a={{ taf.stationId }}" target="_blank">See more details in AOPA weather</a>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #raw>
  <div class="wx__raw">
    <span class="wx__raw-text" [innerHTML]="taf.rawText"></span>
  </div>
  <a href="https://www.aopa.org/weather/?a={{ taf.stationId }}" target="_blank">See more details in AOPA weather</a>
</ng-template>
<ng-template #na>
  <span class="wx__na">N/A</span>
</ng-template>
